import { useCallback } from 'react'
import { logDeliveryDateChange } from '@mindfulchefuk/features/Onboarding/utils/onboardingAnalytics'
import { TOnboardingRecipeFilterHandlers } from '@mindfulchefuk/onboarding/components/OnboardingChooseRecipes/OnboardingChooseRecipesFilters/OnboardingRecipeFilterHandlers.types'

export const useOnDateChange = (): TOnboardingRecipeFilterHandlers['date'] =>
  useCallback(() => {
    logDeliveryDateChange()
  }, [])
